export default __webpack_public_path__ + "static/media/ativmob.3f90dab5.png";